import "../Menu.scss";
import { useState } from "react";
import { Link } from "react-router-dom";
import cookieFeature1 from "../../../assets/menu/cookies/cookie-feature1.jpeg";
import cookieFeature2 from "../../../assets/menu/cookies/cookie-feature2.jpeg";
import cookieFeature3 from "../../../assets/menu/cookies/cookie-feature3.jpeg";
import cookieFeature4 from "../../../assets/menu/cookies/cookie-feature4.jpeg";
import Accordion from "../../../common/Accordion";
import MenuNav from "../MenuNav";
import MenuGallery from "../MenuGallery";
import pricingOptions from "./quantityPricing.json";

function Cookies() {
  const [generalInfoOpened, setGeneralInfoOpened] = useState(false);
  const [quantityPricingOpened, setQuantityPricingOpened] = useState(false);

  return (
    <div className="wrapper">
      <h1>
        <Link to="/menu" className="menu-title-link">
          Menu
        </Link>
      </h1>
      <MenuNav />

      <MenuGallery
        image1={{ src: cookieFeature1, alt: "Transportation themed cookies" }}
        image2={{ src: cookieFeature2, alt: "Kawaii fruit and flower cookies" }}
        image3={{ src: cookieFeature3, alt: "Stork baby shower cookies" }}
        image4={{
          src: cookieFeature4,
          alt: "Young wild and 3 birthday cookies",
        }}
      />

      <Accordion
        className="menu-accordion"
        title="General Information"
        isOpen={generalInfoOpened}
        onToggle={() => setGeneralInfoOpened((prev) => !prev)}
      >
        <div className="full-width">
          <p>
            Allergens: Contains milk, eggs, wheat. All cookies are{" "}
            <strong>free of tree nuts</strong>.
          </p>
          <p>
            Looking for party favors, corporate gifts, or a sweet way to elevate
            your event tablescape? Custom decorated sugar cookies are a tasty
            and elegant way to make any celebration feel more memorable!
          </p>
          <p>
            I offer classic vanilla sugar cookies hand-piped with royal icing,
            each one decorated with careful attention to detail. Every cookie is
            baked thick for a soft, buttery bite, making them just as satisfying
            to eat as they are to look at.
          </p>
          <p>
            Cookies are individually wrapped in resealable cellophane bags. For
            a more elevated presentation, you may also opt for an open
            cellophane packaging tied with ribbon for a gift-ready finish.
          </p>
          <p>
            Edible printing is also available for custom logos, branding, or
            artwork – perfect for adding a personalized touch to corporate
            events, gifts, and special occasions.
          </p>
        </div>
      </Accordion>

      <Accordion
        className="menu-accordion"
        title="Quantity & Pricing"
        isOpen={quantityPricingOpened}
        onToggle={() => setQuantityPricingOpened((prev) => !prev)}
      >
        <div className="full-width">
          <p>
            Minimum order is 1 dozen, but orders beyond the minimum do not need
            to be placed in multiples of a dozen. Pricing varies depending on
            order quantity and design intricacy. To discuss designs for your
            cookie order, please <Link to="/order">submit an order form</Link>{" "}
            to get a customized quote.
          </p>
        </div>
        {pricingOptions.map((option) => (
          <div key={option.id}>
            <h3>{option.size}</h3>
            <p>
              {option.serves}
              <br />
              {option.pricing}
            </p>
          </div>
        ))}
      </Accordion>
    </div>
  );
}

export default Cookies;
